import { ref } from 'vue';

const sortLocalService = (a, b) => {
    return a.localService === b.localService ? 0 : a.localService ? -1 : 1;
};

const allVoices = new Promise(function (resolve) {
    const speechSynthesis = window.speechSynthesis;
    //check if speechSynthesis is supported
    if (!speechSynthesis) {
        resolve([]);
        return;
    }
    let voices = speechSynthesis.getVoices();
    if (voices.length !== 0) {
        voices.sort(sortLocalService);
        resolve(voices);
    } else {
        speechSynthesis.addEventListener('voiceschanged', function () {
            voices = speechSynthesis.getVoices();
            voices.sort(sortLocalService);
            resolve(voices);
        });
    }
});

const voices = ref([]);

export function useVoices() {
    const init = () => {
        if (voices.value.length === 0) {
            allVoices.then((r) => {
                voices.value = r;
            });
        }
    };

    const getVoice = (locales) => {
        let voice = null;
        for (const locale of locales) {
            let key = locale;
            voice = voices.value.find((c) => c.lang.startsWith(key));
            if (voice) {
                return voice;
            }
        }
        return voice;
    };

    return {
        voices,
        getVoice,
        init,
    };
}
